module.exports = __webpack_public_path__ + "c84ff937cd309c223ee886caa5b7894a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/btnText.png
// module id = QyBi
// module chunks = 27